<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-sandstorm`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 27l.24.004a7 7 0 010 13.992L19 41v-4l.176-.005a3 3 0 000-5.99L19 31H2v-4h17zm26 9a2 2 0 110 4 2 2 0 010-4zm-7-3a2 2 0 110 4 2 2 0 010-4zm7-4a2 2 0 110 4 2 2 0 010-4zm-14 0a2 2 0 110 4 2 2 0 010-4zm7-3a2 2 0 110 4 2 2 0 010-4zm-7-4a2 2 0 110 4 2 2 0 010-4zm14 0a2 2 0 110 4 2 2 0 010-4zm-7-3a2 2 0 110 4 2 2 0 010-4zM19 8a7 7 0 01.24 13.996L19 22H8v-4h11a3 3 0 00.176-5.995L19 12V8zm12 7a2 2 0 110 4 2 2 0 010-4zm14 0a2 2 0 110 4 2 2 0 010-4zm-7-3a2 2 0 110 4 2 2 0 010-4zm7-4a2 2 0 110 4 2 2 0 010-4z"/></svg>
</template>
<script>

export default {
  name: 'IconSandstorm',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
